<template>
  <section class="calc">
    <h2 class="calc__title">{{ $t('calc.title') }}</h2>
    <div class="calc__application-position">
      <div id="my-element" class="calc__application" ref="calcApp">
        <iframe
          title="calculator application"
          allow="autoplay"
          id="calculator_frame"
          width="100%"
          height="100%"
          style="border: none; height: 700px; border-radius: 0px;"
          src="https://ekipazh.windowscalculator.net/#/?autologin=b28b4d5b7030f5d2f4ee9f128fd39ec4"
        ></iframe>
      </div>
    </div>
    <!-- <div class="calc__button-position">
      <button class="primary-button" v-motion @click="showModal = true">
        <span>{{ $t('calc.button') }}</span>
        <div class="wave"></div>
      </button>
    </div> -->
    <Teleport to="body">
      <ModalComponent :show="showModal" @close="showModal = false" />
    </Teleport>
  </section>
</template>

<script>
import ModalComponent from '../ModalComponent.vue'
import ScrollMagic from 'scrollmagic';

export default {
  name: 'CalcSectionXxl',
  components: {
    ModalComponent
  },
  data() {
    return {
      showModal: false
    }
  },
  mounted () {
    const controller = new ScrollMagic.Controller();
    new ScrollMagic.Scene({
      triggerElement: '#my-element',
      duration: 1000,
      triggerHook: 0
    })
    .setPin('#my-element')
    .addTo(controller)
  }
}
</script>

<style lang="scss" scoped>
.calc {
  /* margin-bottom: 40px; */

  &__title {
    font-size: 30px;
    /* margin-bottom: 8px; */
    /* margin: 0px 40px 8px 40px; */
    max-width: 1250px;
    padding: 20px 0;
    margin: 0 auto;
  }

  &__application-position {
    /* display: flex; */
    /* justify-content: center; */
    /* align-self: center; */
  }

  &__application {
    min-width: 1024px;
    border-radius: 15px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 20px;
  }

  &__button-position {
    display: flex;
    justify-content: center;
    background-color: green;
  }
}
</style>